/* eslint-disable react/prop-types */
import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Icon from '@ff/ui/Icon';
import url from 'client/utils/url';
import useConfig from 'client/hooks/useConfig';
import { useHistory } from 'react-router-dom';
import { H3 } from 'client/v3/typography';
import appHandlers from 'client/utils/appHandlers';

export default function H5HeaderLayout({ children }) {
  const history = useHistory();
  const qs = useConfig();
  const { NO_BACK_BUTTON } = qs;

  const entryPage = qs.ENTRY_PAGE;
  // If entry page is null in url, that means current page is the entry page.
  if (!entryPage) {
    const { location } = window;
    const currentPage = url.getCurrentPageV3();

    // add entry page into url
    history.replace(`${location.search}&ENTRY_PAGE=${currentPage}`);
    return null;
  }

  const handleCloseClick = appHandlers.getHandlerByKey('CloseConfigurator')
  const handleBackClick = () => {
    const path = url.getPageBackNavigationV3(qs);
    if (path) {
      history.replace(path);
    }
    else {
      setTimeout(appHandlers.getHandlerByKey('CloseConfigurator'), 10);
    }
  }

  const handleShareClick = () => {
    const currentUrl = window.location.href;
    const title = 'Configure My FF 91';
    const text = '';
    
    // Use Web Share API if available
    if (navigator.share) {
      navigator.share({
        title,
        text,
        url: currentUrl,
      }).catch(error => {
        console.log('Error sharing:', error);
        // Only fall back to clipboard if it wasn't a user cancel
        if (error.name !== 'AbortError') {
          copyToClipboard(currentUrl);
        }
      });
    } else {
      // Fallback for browsers without Web Share API
      copyToClipboard(currentUrl);
    }
  };

  // Separate clipboard functionality to reuse
  const copyToClipboard = (text) => {
    // Try to use the clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        alert('Copied to clipboard');
      }).catch(() => {
        fallbackCopyToClipboard(text);
      });
    } else {
      fallbackCopyToClipboard(text);
    }
  };

  // Fallback method using document.execCommand
  const fallbackCopyToClipboard = (text) => {
    const tempInput = document.createElement('input');
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    alert('Copied to clipboard');
  };

  const enabledBackButton = !(NO_BACK_BUTTON === '1');

  return (
    <>
      <Container>
        <Box flex='1' display='flex'>
          {enabledBackButton && (
            <Box width='50%'>
              <BackIcon name='ff-icon-arrow_back_ios' fontSize='22px' onClick={handleBackClick} />
            </Box>
          )}
          <Box width='50%'>
            <CloseIcon name='ff-icon-clear' fontSize='28px' onClick={handleCloseClick} />
          </Box>
        </Box>
        <H3 width='180px' height='30px' textAlign='center'>Configure My FF 91</H3>
        <Box flex='1' display='flex' justifyContent='flex-end' pr='3px'>
          <ShareIcon name='ff-icon-share_2' fontSize='20px' onClick={handleShareClick} />
        </Box>
      </Container>
      <main>
        <Box
          height='50px'
          backgroundColor='rgba(249, 249, 249, 1)'
        ></Box>
        {children}
      </main>
    </>
  );
}

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'fixed',
  top: '0px',
  left: '0px',
  height: '50px',
  display: 'flex',
  alignItems: 'flex-end',
  paddingBottom: '10px',
  color: theme.colors.text01,
  backgroundColor: theme.colors.bg01,
  paddingLeft: '12px',
  paddingRight: '12px',
  zIndex: 999,
}));

const BackIcon = styled(Icon)({
  display: 'block',
  lineHeight: '30px',
  height: '30px',
});

const CloseIcon = styled(Icon)({
  display: 'block',
  lineHeight: '30px',
  height: '30px',
});

const ShareIcon = styled(Icon)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '30px',
  width: '30px',
  cursor: 'pointer',
  color: 'white',
  backgroundColor: 'rgba(60, 60, 60, 0.7)',
  borderRadius: '50%',
  padding: '6px',
});